import adminAxiosInstance from "./api/adminAxiosInstance";

// Busca os consultores usando a nova rota de busca
const searchConsultores = async (
  name = "",
  cpfCnpj = "",
  limit = 20,
  offset = 0
) => {
  const params = new URLSearchParams({
    name,
    cpfCnpj,
    limit,
    offset,
    order: "desc", // Ordena por data de criação, mais recentes primeiro
  });
  // A rota no backend de Contratos de Minérios é 'api/Consultor/search'
  const response = await adminAxiosInstance.get(
    `consultor/search?${params.toString()}`
  );
  console.log(response.data)

  return response.data;
};

// Cria um novo consultor
const createConsultor = async (consultorData) => {
  const response = await adminAxiosInstance.post("consultor", consultorData);
  return response.data;
};

// Atualiza um consultor existente (assumindo que você terá essa rota)
const updateConsultor = async (id, consultorData) => {
    // A rota no backend de Contratos de Minérios é 'api/Consultor/{id}' com método PUT
    const response = await adminAxiosInstance.put(`consultor/${id}`, consultorData);
    return response.data;
  };

// Busca os clientes de um consultor (esta rota continua a mesma)
const getConsultorClients = async (
  consultorId,
  searchTerm = "",
  limit = 10,
  offset = 0
) => {
  const params = new URLSearchParams({ limit, offset });
  if (searchTerm) params.append("searchTerm", searchTerm);
  const response = await adminAxiosInstance.get(
    `consultor/${consultorId}/clients?${params.toString()}`
  );

  return response.data;
};

const getSaleById = async (id) => {
  const response = await adminAxiosInstance.get(`consultor/sale/${id}`);
  return response.data;
};

const updateSaleValue = async (saleId, newValue) => {
  const response = await adminAxiosInstance.patch(`consultor/sale-value/${saleId}`, {
    newValue: newValue
  });
  return response.data;
};

export const consultorService = {
  searchConsultores,
  createConsultor,
  updateConsultor,
  getConsultorClients,
  getSaleById,
  updateSaleValue,
};